<template>
  <div v-if="notification.ShowNotification" class="notification">
    <p>{{ notification.Content }} <a
        v-if="notification.Link"
        :href="notification.Link"
        target="_blank"
      >
        {{ notification.LinkTitle }}
      </a>
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      notification: state => state.notification,
    }),
  },
}
</script>
